import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=cda95e18&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=cda95e18&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda95e18",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/UserProfileComponents/UserCard.vue
// module id = 787
// module chunks = 31